module.exports = __webpack_public_path__ + "assets/whd-icon.png?e28ecb9546005df9a6f1e8c7964100f1";